import React, { useState, useEffect } from 'react';
import { Container, Alert } from 'react-bootstrap';
import { getFromApi } from '../utilities/NetUtilities';
import { buildUrl } from '../helper/handler';
import FiltroSintesiSettimana from './FiltroSintesiSettimana';
import TabellaSintesiSettimana from './TabellaSintesiSettimana';

function SintesiSettimana() {
    const [turni, setTurni] = useState(null);
    const [sedi, setSedi] = useState([]);
    const [servizi, setServizi] = useState([]);
    const [lavoratori, setLavoratori] = useState([]);
    const [message, setMessage] = useState({});
    const [settimana, setSettimana] = useState(null);
    const [sede, setSede] = useState(null);
    const [sediFiltrate, setSediFiltrate] = useState([]);
    const [excelUrl, setExcelUrl] = useState("");

    const handleSintesi = React.useCallback((data) => {
        setTurni(data.turni);
        if (data.lavoratori) {
            setLavoratori(data.lavoratori);
        }
        // Aggiorna la lista sedi filtrate per la visualizzazione
        if (sede && sede.value) {
            const sedeSelezionata = sedi.find(s => s.id === sede.value);
            setSediFiltrate(sedeSelezionata ? [sedeSelezionata] : []);
        } else {
            setSediFiltrate(sedi);
        }
    }, [sede, sedi]);

    const handleSettimana = (data) => {
        setSettimana({ value: data.value, label: data.label });
    };

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setMessageFromApi = (data) => {
            setMessage({ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione })
        }
        const setServiziFromApi = (data) => {
            setServizi(data.servizi);
        }
        const setSediFromApi = (data) => {
            setSedi(data.sedi);
            setSediFiltrate(data.sedi); // Inizializza sediFiltrate con tutte le sedi
        }
        getFromApi(buildUrl('servizi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo }), setServiziFromApi, setMessageFromApi)
        getFromApi(buildUrl('sedi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo }), setSediFromApi, setMessageFromApi);
        getFromApi(buildUrl('settimanaCorrenteTurniLavoro'), handleSettimana, setMessageFromApi);
    }, []);

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        if (!settimana) return;
        const setMessageFromApi = (data) => {
            setMessage({ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione })
        }
        const params = {
            settimana: settimana.value,
            organizzazione: organizzazioneMap.nome,
            tipo: organizzazioneMap.tipo
        };
        if (sede && sede.value) {
            params.sede = sede.value;
        }
        const url = buildUrl('sintesisettimana', params);
        getFromApi(url, handleSintesi, setMessageFromApi);
        if (organizzazioneMap && settimana) {
            const excelParams = {
                settimana: settimana.value,
                organizzazione: organizzazioneMap.nome,
                tipo: organizzazioneMap.tipo
            };
            if (sede && sede.value) {
                excelParams.sede = sede.value;
            }
            setExcelUrl(buildUrl('downloadSintesiSettimanaExcel', excelParams));
        }
    }, [settimana, sede, handleSintesi]);

    const filtroChanged = (nuovaSettimana) => {
        if (!settimana || nuovaSettimana.value !== settimana.value) {
            setSettimana(nuovaSettimana);
        }
    };

    const sedeChanged = (nuovaSede) => {
        setSede(nuovaSede);
    };

    const handleCloseAlert = () => {
        setMessage({});
    };

    return (
        <div className='main' role='main'  onClick={handleCloseAlert}>
            <h1 className="d-flex justify-content-center inEvidenza">Sintesi Settimana</h1>
            {message.descrizione && (
                <Alert variant={message.tipo} id="message" >
                    {message.descrizione}
                </Alert>
            )}
            <Container>
                <div>
                    <FiltroSintesiSettimana 
                        setMessage={setMessage} 
                        settimana={settimana} 
                        filtroChanged={filtroChanged}
                        sedi={sedi}
                        sede={sede}
                        sedeChanged={sedeChanged}
                    />
                </div>
            </Container>
            <Container fluid>
                {turni && <TabellaSintesiSettimana turni={turni} sedi={sediFiltrate} servizi={servizi} lavoratori={lavoratori} excelUrl={excelUrl} />}
            </Container>
        </div>
    );
}

export default SintesiSettimana;